import {BookingStatus, ServiceTypeEnum, XpressClientLocationTypeEnum, XpressDeliveryStatus} from '../models';
import {StylesStatus} from 'app/models/users/StylesStatus';
import { CustomWindow } from 'app/@types';

declare let window: CustomWindow;

export class OrderUtils {
    private static readonly bookingLabelDisplayNames: Record<string, string> = {
        B2B: 'Back To Back',
    };

    private static readonly statusDisplayNames: Record<string, string> = {
        'Assigned B2B': 'Assigned Back To Back',
    };

    public static getBookingLabelDisplayText(label: string): string {
        return OrderUtils.bookingLabelDisplayNames[label] ?? label;
    }

    public static getStatusDisplayText(statusText: string): string {
        return OrderUtils.statusDisplayNames[statusText] ?? statusText;
    }

    public static getActiveOrderLocalStatusText(statusId: XpressDeliveryStatus): BookingStatus {
        switch (statusId) {
            case XpressDeliveryStatus.New:
            case XpressDeliveryStatus.RiderAssigning:
                return BookingStatus.Requesting;
            case XpressDeliveryStatus.RiderAssigned:
                return BookingStatus.Assigned;
            case XpressDeliveryStatus.RiderAccept:
                return BookingStatus.Accepted;
            case XpressDeliveryStatus.RiderAcceptB2B:
                return BookingStatus.Assigned;
            case XpressDeliveryStatus.ArrivedToPickup:
                return BookingStatus.WaitingForPassenger;
            case XpressDeliveryStatus.PickedUp:
            case XpressDeliveryStatus.ArrivedToDrop:
                return BookingStatus.OnTrip;
            case XpressDeliveryStatus.Completed:
                return BookingStatus.Completed;
            case XpressDeliveryStatus.Canceled:
                return BookingStatus.Canceled;
            case XpressDeliveryStatus.Rejected:
                return BookingStatus.Rejected;
            default:
                return BookingStatus.Unknown;
        }
    }

    public static getActiveOrderStatusStyles(status: BookingStatus): StylesStatus {
        let backgroundColor: string;
        let textColor: string;

        switch (status) {
            case BookingStatus.Requesting:
                backgroundColor = '#FFC043';
                textColor = '#004060';
                break;
            case BookingStatus.PickingUp:
                backgroundColor = '#A1BDCA';
                textColor = '#004060';
                break;
            case BookingStatus.Completed:
                backgroundColor = '#1CBA70';
                textColor = '#FFFFFF';
                break;
            case BookingStatus.Arrived:
                backgroundColor = '#0A84FF';
                textColor = '#FFFFFF';
                break;
            case BookingStatus.Accepted:
                backgroundColor = '#9C27B0';
                textColor = '#FFFFFF';
                break;
            case BookingStatus.WaitingForPassenger:
                backgroundColor = '#F77F00';
                textColor = '#FFFFFF';
                break;
            case BookingStatus.WaitingExtended:
                backgroundColor = '#A53D27';
                textColor = '#FFFFFF';
                break;
            case BookingStatus.Canceled:
            case BookingStatus.Unallocated:
            case BookingStatus.Rejected:
                backgroundColor = '#EB4236';
                textColor = '#FDEBEA';
                break;
            case BookingStatus.Assigned:
                backgroundColor = '#A1BDCA';
                textColor = '#004060';
                break;
            case BookingStatus.OnTrip:
                backgroundColor = '#0A84FF';
                textColor = '#FFFFFF';
                break;
            default:
                backgroundColor = '';
                textColor = '';
        }

        return {
            backgroundColor,
            color: textColor
        };
    }

    public static getOrderStatusStyles(status: XpressDeliveryStatus): StylesStatus {
        let backgroundColor: string;
        let textColor: string;

        switch (status) {
            case XpressDeliveryStatus.New:
            case XpressDeliveryStatus.RiderAssigning:
                backgroundColor = '#FFC043';
                textColor = '#004060';
                break;
            case XpressDeliveryStatus.ArrivedToPickup:
                backgroundColor = '#A1BDCA';
                textColor = '#004060';
                break;
            case XpressDeliveryStatus.Completed:
                backgroundColor = '#1CBA70';
                textColor = '#FFFFFF';
                break;
            case XpressDeliveryStatus.Canceled:
            case XpressDeliveryStatus.Rejected:
                backgroundColor = '#EB4236';
                textColor = '#FDEBEA';
                break;
            case XpressDeliveryStatus.RiderAssigned:
                backgroundColor = '#A1BDCA';
                textColor = '#004060';
                break;
            case XpressDeliveryStatus.RiderAccept:
                backgroundColor = '#9C27B0';
                textColor = '#FFFFFF';
                break;
            case XpressDeliveryStatus.RiderAcceptB2B:
                backgroundColor = '#A1BDCA';
                textColor = '#004060';
                break;
            case XpressDeliveryStatus.ArrivedToDrop:
                backgroundColor = '#0A84FF';
                textColor = '#FFFFFF';
                break;
            default:
                backgroundColor = '';
                textColor = '';
        }

        return {
            backgroundColor,
            color: textColor
        };
    }

    public static isForceAssignVisible(
        serviceTypeId?: number | null,
        isScanAndRide: boolean = false,
        clientLocationType?: XpressClientLocationTypeEnum | null
    ): boolean {
        if (isScanAndRide) {
            return false;
        }

        if (serviceTypeId === ServiceTypeEnum.Connex) {
            return true;
        }

        if (typeof window === 'undefined') {
            return false;
        }

        if (window['showForceAssign'] === true) {
            return true;
        }

        return clientLocationType === XpressClientLocationTypeEnum.Boracay
            && window['showForceAssignBoracay'] === true;
    }
}
